const teamInfo = [
    {
        "name": "undefyned",
        "info": "Designer & Developer",
        "profileImage": "https://raw.githubusercontent.com/undefyned/personal_assets/master/imundefyned.png",
        "linkOne": "https://twitter.com/imundefyned",
        "linkOneTitle": "Twitter",
        "linkTwo": "https://t.me/undefyned",
        "linkTwoTitle": "Telegram",
        "linkThree": "https://play.google.com/store/apps/dev?id=7214877496540262106",
        "linkThreeTitle": "Play Store",
        "linkFour": "https://t.me/defyned",
        "linkFourTitle": "Group"
    },
    {
        "name": "Wallpeppers",
        "info": "Also available on Google Play",
        "profileImage": "https://lh3.googleusercontent.com/EvO-bYmOS2oDeoTMj8uPpucoVjVIzB152ybpJCrQ_DwenlitPBjdkY6ZYJJol-ZxCCo",
        "linkOne": "https://play.google.com/store/apps/details?id=ml.undefyned.wallpeppers",
        "linkOneTitle": "Download",
        "linkTwo": "",
        "linkTwoTitle": "",
        "linkThree": "",
        "linkThreeTitle": "",
        "linkFour": "",
        "linkFourTitle": ""
    }
    // Add additional sections here
]

export default teamInfo;